
import './Teenused.css';
import {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Button, Navbar, Container, Nav, NavDropdown, Card, Row, Col, Image, Table, ThemeProvider } from 'react-bootstrap';

export default function Hero() {

    return (
      <div className='main'>
        <Container>

        
          <Container style={{marginBottom:"2.5rem", fontWeight:"500", textAlign:"start", color:"#43ACE7",}}>
           <h1 style={{color:"#43ACE7", textAlign:"center"}}>
            <strong >Täiskasvanute Ortodontia</strong>
          </h1>
            <p style={{color:"#43ACE7", fontWeight:"500", textAlign:"start"}}></p>
            <h4 style={{ color: "#43ACE7", fontWeight: "500" }}>
        Kui kaua breketiravi kestab?
      </h4>

      <p style={{ textAlign: "start" }}>
        Breketiravi kestus täiskasvanutel võib olla üsna erinev.
      </p>

      <h5>Keskmine kestus</h5>
      <p>Tavaliselt: umbes 1,5 – 2 aastat</p>

      <p>Mõnel juhul:</p>
      <ul>
        <li>Kergemad probleemid: ~6–12 kuud</li>
        <li>Keerulisemad juhud: kuni 2,5–3 aastat</li>
      </ul>

      <h4 style={{ color: "#43ACE7", fontWeight: "500" }}>
        Millest kestus sõltub?
      </h4>

      <p>Ravi pikkust mõjutavad mitmed tegurid:</p>

      <ul>
        <li>
          Hammaste asetuse või hambumuse keerukus (kui palju ja milliseid
          hambaid tuleb nihutada soovitud tulemuse saavutamiseks – kas ainult
          esihambaid või kaasatakse ka tagumised hambad).
        </li>

        <li>
          Kas hambad vajavad ainult kergemat reastamist ja esteetilise poolega
          jätkab oma hambaarst või vajate ettevalmistust suuremaks
          proteesitööks (kroonid, sillad, ruumi loomine puuduvate hammaste
          asendamiseks implantaatidega).
        </li>

        <li>
          Kas lõualuud vajavad korrigeerimist (kirurgiline korrektsioon).
        </li>

        <li>
          Kas kasutatakse lisaseadmeid (nt laiendajad, elastikud, minikruvid, IPR).
        </li>

        <li>
          Kui hästi patsient juhiseid järgib (nt elastikute kandmine,
          visiitidel käimine, raviseadmetega hoolikas ümberkäimine ja
          toitumissoovituste järgimine). Samuti võivad mõned ravimid
          aeglustada hammaste nihkumist (nt ibuprofeen).
        </li>
      </ul>

      <h4 style={{ color: "#43ACE7", fontWeight: "500" }}>
        Oluline teada
      </h4>

      <ul>
        <li>
          Pärast breketite eemaldamist ravi ei lõpe kohe. Järgneb
          retentsiooniperiood ehk säilitamise periood (vähemalt ~2 aastat),
          et hambad oma vanadele kohtadele tagasi ei liiguks.
        </li>

        <li>
          Retention for Life – paljudel juhtudel on tulemuse säilitamine
          vajalik nii kaua, kui soovite, et hambad sirged püsiksid.
        </li>

        <li>
          NB! Proteesitöid nagu kroonid, sillad, esihammaste laminaadid
          ja lumineerid ning suukirurgiat (sealhulgas jäävhammaste
          eemaldamist) meie kliinikus ei tehta.
        </li>
      </ul>
      </Container>
          </Container>

        </div>
    );
}